import API from '../../../../common/http/api.fetch';
import { PNP_SETTINGS_APPROVAL_WORKFLOW_RESET, PNP_SETTINGS_APPROVAL_WORKFLOW_DETAILS } from '../pnp-settings.actions.types';
import { IDS } from './pnp-approval-workflow.constants';

export const getSettingsApprovalWorkflow = (filter) => {
    return (dispatch) => {
        return API.fetch({
            url: `/pnp/doc-approval-workflows`,
            method: 'GET',
            params: {
                location: filter.location,
                offset: filter.offset,
                limit: Number.isFinite(filter.limit) ? filter.limit : 10,
                documentCategory: filter.documentCategory,
                exportFormat: filter.exportFormat,
                exportColumns: filter.exportColumns
            }
        }).then(({ data }) => {
            if (filter.exportFormat) {
                return data;
            }
            dispatch({
                type: 'GRID_FETCH',
                id: IDS.pnpSettingsApprovalWorkflowGrid,
                items: data.items.map((item) => {
                    return {
                        id: item.id,
                        reviewers: item.reviewers,
                        approvers: item.approvers,
                        documentCategory: item.document_category,
                        documentRiskLevels: item.document_risk_levels,
                        documentGroupUUID: item.group_uuid
                    }
                }),
                itemsCount: parseInt(data.items_count)
            })
        });
    }
}

export const saveSettingsApprovalWorkflow = (data) => {
    const reviewers = [];
    const approvers = [];

    data.documentRiskLevel.forEach((riskLevel) => {
        data.selectedReviewers.forEach((reviewer) => {
            reviewers.push({ container_type: reviewer.value, risk_level: riskLevel })
        });

        data.selectedApprovers.forEach((reviewer) => {
            approvers.push({ container_type: reviewer.value, risk_level: riskLevel })
        });
    });

    return (dispatch) => {
        return API.fetch({
            url: `/pnp/doc-approval-workflow/save`,
            method: 'POST',
            data: {
                id: data.id,
                name: data.name,
                documentCategory: data.documentCategory,
                reviewers,
                approvers,
                uuid: data.documentGroupUUID
            }
        }).then((response) => {
            dispatch({
                type: 'GRID_RELOAD',
                id: IDS.pnpSettingsApprovalWorkflowGrid
            })
            if (!data.id) {
                dispatch({
                    type: PNP_SETTINGS_APPROVAL_WORKFLOW_RESET,
                    id: IDS.pnpSettingsApprovalWorkflow
                });
            }
        });
    }
}

export const getSettingsApprovalWorkflowDetails = (id, uuid) => {
    return (dispatch) => {
        return API.fetch({
            url: `/pnp/doc-approval-workflow/details`,
            method: 'GET',
            params: { id, uuid }
        }).then(({ data }) => {
            dispatch({
                type: PNP_SETTINGS_APPROVAL_WORKFLOW_DETAILS,
                id: IDS.pnpSettingsApprovalWorkflow,
                data: data[0],
            })
        });
    }
};

export const deleteSettingsApprovalWorkflow = (id, uuid) => {
    return (dispatch) => {
        return API.fetch({
            url: `/pnp/doc-approval-workflow/archive`,
            method: 'GET',
            params: { id, uuid }
        }).then(() => {
            dispatch({
                type: 'GRID_RELOAD',
                id: IDS.pnpSettingsApprovalWorkflowGrid
            })
        });
    }
};
